import { useState, useEffect } from 'react';
import { tripsApi } from '../api/trips.api';
import { Trip, TripFilters } from '../types/trip';

export const useTrips = (filters?: TripFilters) => {
  const [data, setData] = useState<Trip[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
    hasMore: false,
  });

  const fetchTrips = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await tripsApi.getTrips(filters);
      setData(response.data);
      setPagination(response.pagination);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to fetch trips');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTrips();
  }, [
    filters?.startDate,
    filters?.endDate,
    filters?.driverId,
    filters?.vehicleId,
    filters?.qualification,
    filters?.page,
    filters?.limit,
  ]);

  return {
    data,
    isLoading,
    error,
    pagination,
    refetch: fetchTrips,
  };
};

export const usePendingTrips = () => {
  const [data, setData] = useState<Trip[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPendingTrips = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await tripsApi.getPendingTrips();
      setData(response.data);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to fetch pending trips');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingTrips();
  }, []);

  return {
    data,
    isLoading,
    error,
    refetch: fetchPendingTrips,
  };
};
